export default "__VITE_ASSET__ee5d116c__"